//packages
import React, { Component } from 'react'

//form elements
import PopoverOfForm from '../../PopoverOfForm'

class CaseNumberTooltip extends Component {
    render () {
        return (
            <PopoverOfForm>
                <p>Case numbers can be entered in any of the following formats:</p>
                <ul>
                    <li>yy-nnnnn</li>
                    <li>yy-tp-nnnnn</li>
                    <li>yy tp nnnnn</li>
                    <li>yytpnnnnn</li>
                    <li>o:yy-nnnnn</li>
                    <li>o:yy-tp-nnnnn</li>
                    <li>o:yy tp nnnnn</li>
                    <li>o:yytpnnnnn</li>
                </ul>
                <table>
                    <tbody>
                    <tr><th>o</th><td>office where the case was filed (1 digit)</td></tr>
                    <tr><th>yy</th><td>case year (2 or 4 digits)</td></tr>
                    <tr><th>tp</th><td>case type (up to 2 characters)</td></tr>
                    <tr><th>nnnnn</th><td>case number (up to 5 digits)</td></tr>
                    </tbody>
                </table>
            </PopoverOfForm>
        )
    }
}

export default CaseNumberTooltip



/** WEBPACK FOOTER **
 ** ./src/components/search/FormElements/tooltips/caseNumberTooltip/CaseNumberTooltip.js
 **/